import { ITEM_FAMILY_SECTIONS } from "./item-status";
import { ItemRow } from "./item-row";
import type { ReportReview } from "./use-report-review";
import type { RunReport, RunScope } from "../types";

export const ITEMS_PENDING_MESSAGE =
  "Items can be reviewed once all sources finish.";

/** One row per item, grouped by family. */
export function ReportItems({
  data,
  scope,
  canEdit,
  review,
}: {
  data: RunReport;
  scope: RunScope;
  canEdit: boolean;
  review: ReportReview;
}) {
  const collecting = data.items.some((item) => item.decision === null);
  return (
    <div className="space-y-4">
      {collecting && (
        <p role="status" className="text-sm text-muted-foreground">
          {ITEMS_PENDING_MESSAGE}
        </p>
      )}
      {ITEM_FAMILY_SECTIONS.map((section) => {
        const items = data.items.filter(
          (item) => String(item.family) === section.family,
        );
        if (items.length === 0) {
          return null;
        }
        return (
          <section
            key={section.family}
            className="space-y-2"
            aria-label={section.label}
          >
            <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
              {section.label}
            </h3>
            {items.map((item) => (
              <ItemRow
                key={item.key}
                item={item}
                checks={data.checks}
                runId={data.run.id}
                scope={scope}
                expanded={review.isExpanded(item)}
                canEdit={canEdit}
                decisions={review.decisions}
                uploadFocusRequested={review.uploadFocusKey === item.key}
                onToggle={() => review.toggle(item)}
                onUploadFocused={review.clearUploadFocus}
                onAccept={() => review.accept(item)}
                onConcern={() => review.concern(item)}
                onUndo={() => review.undo(item)}
              />
            ))}
          </section>
        );
      })}
      {data.items.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No applicable source results are recorded for this run.
        </p>
      )}
    </div>
  );
}
